"use client";

import { CoreFeaturesSection } from "@/components/sections/core-features";
import { coreFeatures } from "@/lib/data/services-competitive-intelligence";

export function CoreFeatures() {
  return (
    <CoreFeaturesSection
      eyebrow={coreFeatures.eyebrow}
      title={coreFeatures.title}
      accent={coreFeatures.accent}
      featureAccents={coreFeatures.featureAccents}
      features={coreFeatures.features}
    />
  );
}